var map = {
	"./Bienvenida.png": 137,
	"./Fav.png": 390,
	"./Mabel_NH.webp": 397,
	"./Resetti.png": 288,
	"./Tom_Nook.webp": 45,
	"./Vector.png": 818,
	"./corazon.png": 806,
	"./discord.png": 889,
	"./facebook.png": 141,
	"./favorito.png": 735,
	"./flecha.png": 537,
	"./footerOceano.png": 692,
	"./foto3.jpg": 474,
	"./instagram.png": 723,
	"./isabelle2.png": 365,
	"./leafpattern.png": 915,
	"./leafpattern2.png": 378,
	"./leafpattern2osc.png": 246,
	"./leafpatternosc.png": 803,
	"./logo.webp": 437,
	"./luna.png": 125,
	"./mano.png": 228,
	"./persona.png": 294,
	"./sol.png": 81,
	"./twitter.png": 591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;